import React from 'react'

import SelectGroupedType from './select-type/select-type'

type Props = {
    onSelectType    : {(type: any, templateId: ID): void}
}

// const debug = "NewProject_SelectTemplateFromLibrary"
const debug = false

export default function NewProject_SelectTemplateFromLibrary(props: Props) {
    return (
        <div className="new-main project select-templates-library">
            <SelectGroupedType onSelect={props.onSelectType}/>
        </div>
    )

}
